import React from 'react';
import './index.css';
import Login from './Login.js';
import Portal from './Portal.js';
import ETVActionButton from './tools/ETVActionButton.js';
import ETVMessagePopup from './tools/ETVMessagePopup.js';
import { IntlProvider} from 'react-intl';
import * as ETVConstants from './ETVConstants';
import en from "./intl/en.json";
import de from "./intl/de.json";
import jp from "./intl/jp.json";
import vn from "./intl/vn.json";
import th from "./intl/th.json";
import fr from "./intl/fr.json";
import { SESSION_EXPIRED_EVENT, resetSessionExpiryNotification } from './tools/AuthSession.js';

class ElevatorTV extends React.Component{

  constructor(props) {
    super(props);

    this.events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress"
    ];

    this.warn = this.warn.bind(this);
    this.logout = this.logout.bind(this);
    this.resetTimeout = this.resetTimeout.bind(this);
    this.langCallback = this.langCallback.bind(this);
    this.handleSessionExpired = this.handleSessionExpired.bind(this);

    for (var i in this.events) {
      window.addEventListener(this.events[i], this.resetTimeout);
    }
    this.loggedInFunc = this.loggedInFunc.bind(this);
    this.setTimeout();
    var lang = this.getUserLanguage();
    this.state.lang = lang;
  }

  getUserLanguage() {
      var userLang = navigator.language || navigator.userLanguage;
      //console.log("userLang="+userLang);
      if(userLang.indexOf("de")>=0) return "de";
      return "en";
  }

  state = {
    lang:'en',
    loggedin:false,
    user_id:undefined,
    roles: undefined,
    children:[],
    show_overlay: false,
    window: undefined,
    info_message_title: undefined,
    info_message: undefined,
    sessionExpired: false,
  }

  componentDidMount() {
    window.addEventListener(SESSION_EXPIRED_EVENT, this.handleSessionExpired);
  }

  componentWillUnmount() {
    window.removeEventListener(SESSION_EXPIRED_EVENT, this.handleSessionExpired);
    this.destroy();
  }

  handleSessionExpired() {
    this.clearTimeout();
    this.setState({
      loggedin:false,
      sessionExpired:true,
      user_id:undefined,
      roles:undefined,
      children:[],
      info_message_title:this.trans('session_expired'),
      info_message:this.trans('session_expired_sign_in_again'),
      window:'message_div',
      show_overlay:true,
    });
  }

  langCallback( lang) {
    this.setState({lang:lang});
  }

  setTimeout() {
    if(this.state.loggedin) {
      this.warnTimeout = setTimeout(this.warn, 300 * 1000);
      this.logoutTimeout = setTimeout(this.logout, 360 * 1000);
    }
  }

  clearTimeout() {
     if (this.warnTimeout) clearTimeout(this.warnTimeout);
     if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
   }

   logout() {
       // Send a logout request to the API
       //console.log("Sending a logout request.");
       this.closeInfoMessage();
       this.setState({ loggedin: false });
       // this.destroy(); // Cleanup
   }

   resetTimeout() {
      this.clearTimeout();
      this.setTimeout();
   }

   trans( msgID) {
     return ETVConstants.trans(msgID);
   }

   warn() {
     this.showInfoMessage(this.trans('automatic_logout'),this.trans('inactive_session_you_will_be_logged_out_automatically_in_1_minute'));
   }

   showInfoMessage(title,text) {
     this.setState({info_message_title:title,info_message:text});
     this.showWindow('message_div',true);
   }

   closeInfoMessage() {
     this.setState({info_message:undefined});
     this.showWindow('message_div',false);
   }

   showWindow(divID, show) {
     //console.log("show window="+divID+" show="+show);
     this.setState({show_overlay:show});
     show?this.setState({window:divID}):this.setState({window:''});
   }

   destroy() {
      this.clearTimeout();
      for (var i in this.events) {
        window.removeEventListener(this.events[i], this.resetTimeout);
      }
  }

  loggedInFunc(success, userID, username, roles, children, status, lang) {
    if(success) resetSessionExpiryNotification();
    this.setState({
        loggedin: success,
        user_id: userID,
        username: username,
        roles: roles,
        children:children,
        status: status,
        lang:lang,
        sessionExpired:false,
      });
  }

  clickNotLogout() {
    this.closeInfoMessage();
    this.resetTimeout();
  }

  render() {
      const messages = {en,de,jp,vn,th,fr};
      ETVConstants.setTranslationLanguage(this.state.lang);
      return(
        <IntlProvider locale={this.state.lang && this.state.lang.length>0?this.state.lang:"en"} messages={messages[this.state.lang?this.state.lang:'en']}>
        <div>
          {this.state.loggedin?
              <div><Portal lang={this.state.lang} langCallback={this.langCallback} loggedInCallback={this.loggedInFunc} user_id={this.state.user_id} username={this.state.username} roles={this.state.roles} children={this.state.children} status={this.state.status} /></div>
              :
              <div><Login lang={this.state.lang} loggedInCallback={this.loggedInFunc} /></div>
          }
          <ETVMessagePopup
            open={this.state.window==='message_div'}
            onClose={()=>this.state.sessionExpired ? this.setState({window:'',show_overlay:false,info_message:undefined,sessionExpired:false}) : this.clickNotLogout()}
            type={this.state.sessionExpired ? 'error' : 'info'}
            title={this.state.info_message_title}
            message={this.state.info_message}
            actions={this.state.sessionExpired
              ? <ETVActionButton action="cancel" label={this.trans('close')} onClick={()=>this.setState({window:'',show_overlay:false,info_message:undefined,sessionExpired:false})}/>
              : <><ETVActionButton action="cancel" label="Stay signed in" onClick={()=>this.clickNotLogout()}/><ETVActionButton action="send" label={this.trans('logout')} onClick={()=>this.logout()}/></>}
          />
          </div>
          </IntlProvider>
      )
  }
}

export default ElevatorTV
